import rolesApi from '../../../api/modules/roles'

function StorageSetObject (key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

let fetchRolesPromise = null

export default {
  refesh () {
    this.axios.get('/api/jiraProjects',
      {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        if (response.status === 200) {
          this.projects = response.data
        }
      })
      .catch(console.error)
  },
  setPermission ({ commit }, payload) {
    commit('SET_PERMISSION', JSON.stringify(payload))
    localStorage.setItem('permission', JSON.stringify(payload))
  },
  setNotEstimatedIssues ({ commit }, payload) {
    commit('SET_NOT_ESTIMATED_ISSUES', payload)
  },
  setNotBudgetIssues ({ commit }, payload) {
    commit('SET_NOT_BUDGET_ISSUES', payload)
  },
  setExpensesCategories ({ commit }, payload) {
    commit('SET_EXPENSES_CATEGORIES', payload)
  },
  setExpensesStatuses ({ commit }, payload) {
    commit('SET_EXPENSES_STATUSES', payload)
  },
  setCurrencies ({ commit }, payload) {
    commit('SET_CURRENCIES', payload)
  },
  setBankCards ({ commit }, payload) {
    commit('SET_BANK_CARDS', payload)
  },
  setOwnBankDetails ({ commit }, payload) {
    commit('SET_OWN_BANK_DETAILS', payload)
  },
  setAllUsers ({ commit }, payload) {
    commit('SET_ALL_USERS', payload)
  },
  setAllPermission ({ commit }, payload) {
    commit('SET_ALL_PERMISSION', payload)
  },
  async fetchRoles ({ commit, state }) {
    if (state.roles.length) {
      return Promise.resolve(state.roles)
    }
    if (fetchRolesPromise) {
      return fetchRolesPromise
    }

    fetchRolesPromise = rolesApi.getRoles()
      .then((roles) => {
        commit('SET_ROLES', roles)
        return roles
      })
      .catch((error) => {
        console.error('roles:', error)
        throw error
      })
      .finally(() => {
        fetchRolesPromise = null
      })

    return fetchRolesPromise
  },
  setRoles ({ commit }, payload) {
    commit('SET_ROLES', payload)
  },
  setIssueTypes ({ commit }, payload) {
    commit('SET_ISSUE_TYPES', payload)
  },
  setIssueStatuses ({ commit }, payload) {
    commit('SET_ISSUE_STATUSES', payload)
  },
  setCurrentUserRole ({ commit }, payload) {
    commit('SET_CURRENT_USER_ROLE', payload)
  },
  setUser ({ commit }, payload) {
    commit('SET_USER', payload)
    StorageSetObject('user', payload)
  },
  setAccessToken ({ commit }, payload) {
    commit('SET_ACCESS_TOKEN', payload)
    localStorage.setItem('access_token', payload)
  },
  setUserRoles ({ commit }, payload) {
    commit('SET_USER_ROLE', JSON.stringify(payload))
    localStorage.setItem('user_roles', JSON.stringify(payload))
  },
  setUserName ({ commit }, payload) {
    commit('SET_USER_NAME', payload)
    localStorage.setItem('user_name', payload)
  },
  setUserId ({ commit }, payload) {
    commit('SET_USER_ID', payload)
    localStorage.setItem('user_id', payload)
  },
  setActive ({ commit }, payload) {
    commit('SET_ACTIVE', payload)
  },
  toggleSidebar ({ commit }, payload) {
    commit('TOGGLE_SIDEBAR', payload)
    localStorage.setItem('show_sidebar', payload)
  },
  setIsJiraAuth ({ commit }, payload) {
    commit('IS_JIRA_AUTH', payload)
  }
}
